import { Box, Grid, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import useReactiveQuery from "../../hooks/data/useReactiveQuery";
import { Image } from "../reusables";
import useImageCompressor from "../../hooks/useImageCompressor";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router";

/**
 *
 * @param {import("@chakra-ui/react").StackProps & {id: string,
 * imageContainerProps: import("@chakra-ui/react").BoxProps,
 * title: import("@chakra-ui/react").TextProps,
 * description: import("@chakra-ui/react").TextProps}} props
 *
 */
export default function ProductListItem(props) {
  const { get } = useReactiveQuery();
  const { id, imageContainerProps, title, description, ...containerProps } =
    props;
  const product = get(["products", id]);
  const { findClosestMatch } = useImageCompressor();
  const imageContainerRef = useRef();
  const [currentImage, setCurrentImage] = useState();

  useEffect(() => {
    if (product && !currentImage) setCurrentImage(product?.images[0]);
  }, [currentImage, product]);

  const imageFileName = useMemo(
    () =>
      findClosestMatch(currentImage?.compressed, imageContainerRef)?.fileName,
    [currentImage]
  );

  return (
    <Stack
      spacing={"3"}
      role="group"
      as={Link}
      to={`/user/${product?.user?.username}/product/${product?.id}`}
      textDecor="none !important"
      borderRadius={"lg"}
      _hover={{
        bg: "#30303640",
      }}
      direction={"row"}
      {...containerProps}
    >
      <Box
        bg="#2a2a2c"
        borderRadius={"lg"}
        h="70px"
        w="70px"
        transition={"all 200ms"}
        _groupHover={{
          transform: "scale(1.02)",
        }}
        {...imageContainerProps}
      >
        <Image
          ref={imageContainerRef}
          firebaseStoragePath={
            product?.images
              ? `photos/${product?.user?.id}/products/${product?.id}/images/${imageFileName}`
              : null
          }
          w="full"
          h="full"
          objectFit={"cover"}
          borderRadius="lg"
        />
      </Box>
      <VStack w="full" align={"flex-start"} spacing={"0.5"} justify={"center"}>
        <Text noOfLines={2} fontSize={"sm"} fontWeight={"semibold"} {...title}>
          {product?.name}
        </Text>
        <Text
          fontSize={"12px"}
          transition={"all 150ms"}
          opacity={"0.6"}
          _groupHover={{
            opacity: "1",
          }}
          {...description}
        >
          {product?.variations?.length > 1
            ? `Multiple ${product?.variations?.map((variation) => variation.name)?.join(", ")}`
            : `Starts from $${product?.pricingData?.sort((a, b) => a.amount - b.amount)[0]?.amount}`}
        </Text>
      </VStack>
    </Stack>
  );
}
